<template>
    <div class="card-edit-history">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="update_datetime" label="时间" width="160" />
            <el-table-column prop="count_type" label="卡项类别" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.count_type === '1'">次卡</span>
                    <span v-else-if="scope.row.count_type === '2'">时卡</span>
                    <span v-else-if="scope.row.count_type === '3'">通卡</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="180" show-overflow-tooltip>
                <template slot-scope="scope" >
                    {{scope.row.title}}
                    <span v-if="scope.row.count_type !== '2'">( {{scope.row.count_num}}次 )</span>
                </template>
            </el-table-column>
            <el-table-column prop="valid_day" label="有效时间">
                <template slot-scope="scope">
                    <span v-if="scope.row.valid_day > 0">{{scope.row.valid_day}}天</span>
                    <span v-else>永久有效</span>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="售价" />
            <el-table-column prop="sale_num" label="销量">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleSale(scope.row)">
                        {{scope.row.sale_num}}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleEdit(scope.$index, scope.row)">
                        查看权益
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="update_desc" label="描述" width="200" />
            <el-table-column prop="store_name" label="门店" width="150" />
        </el-table>
        <div class="page-box">
            <el-pagination
                    @size-change="pageSizeChange"
                    @current-change="pageCurrentChange"
                    :current-page="page.nowPage"
                    :page-sizes="page.pageSizes"
                    :page-size="page.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.count">
            </el-pagination>
        </div>

        <!--权益-->
        <card-edit-history-product v-model="cardProductState" :card-info="cardInfo" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import CardEditHistoryProduct from "@/model/Card/CardEditHistoryProduct";
    export default {
        name: "CardEditHistory",
        components: {CardEditHistoryProduct},
        props: {
            cardId: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            tableData: [],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            //权益
            cardProductState: false,
            cardInfo: {}
        }),
        methods: {
            //加载数据
            loadHistoryData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    card_id: this.cardId
                };
                obj.postData("card/get_edit_history", postData, res => {
                    if(res.errcode === 0){
                        this.tableData = res.data;
                        this.page.count = res.count;
                    }
                });
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadHistoryData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadHistoryData();
            }

            //查看权益
            ,handleEdit: function (index, data) {
                this.cardInfo = data;
                this.cardProductState = true;
            }

            //查看销售记录
            ,handleSale: function (data) {
                this.$root.log(data);
                this.$root.go("card/card_sale_list", {
                    card_id: data.card_id,
                    start_date: data.update_datetime ? data.update_datetime : "",
                    end_date: data.next_update_time ? data.next_update_time : ""
                });
            }
        },
        watch: {
            cardId: function (val) {
                this.loadHistoryData();
            }
        }
    }
</script>

<style scoped>
    .page-box{
        text-align: right;
    }
</style>
